export default __webpack_public_path__ + "static/media/Asset-72.5cb8ca49.png";